import { render, staticRenderFns } from "./TaskPhotos.vue?vue&type=template&id=0d724a65&"
import script from "./TaskPhotos.vue?vue&type=script&lang=ts&"
export * from "./TaskPhotos.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports